import React, { Component } from "react";
import styled from "styled-components";

import SortIcon from "react-icons/lib/fa/sort";
import SortNumericDescIcon from "react-icons/lib/fa/sort-numeric-desc";
import SortNumericAscIcon from "react-icons/lib/fa/sort-numeric-asc";
import SortAlphaDescIcon from "react-icons/lib/fa/sort-alpha-desc";
import SortAlphaAscIcon from "react-icons/lib/fa/sort-alpha-asc";
import SortAmountDescIcon from "react-icons/lib/fa/sort-amount-desc";
import SortAmountAscIcon from "react-icons/lib/fa/sort-amount-asc";

class TableHeader extends Component {
  render() {
    const {
      title,
      setSort,
      sortField,
      sortType,
      currentSortDir,
      currentSortField
    } = this.props;

    const sortDirOnClick = currentSortDir === "asc" ? "desc" : "asc";

    const size = 15;

    let sortIcon = sortField && <SortIcon size={size} />;

    if (currentSortField === sortField) {
      switch (sortType) {
        case "alpha":
          sortIcon =
            currentSortDir === "asc" ? (
              <SortAlphaAscIcon size={size} />
            ) : (
              <SortAlphaDescIcon size={size} />
            );
          break;
        case "amount":
          sortIcon =
            currentSortDir === "asc" ? (
              <SortAmountAscIcon size={size} />
            ) : (
              <SortAmountDescIcon size={size} />
            );
          break;
        case "numeric":
          sortIcon =
            currentSortDir === "asc" ? (
              <SortNumericAscIcon size={size} />
            ) : (
              <SortNumericDescIcon size={size} />
            );
          break;
        default:
          sortIcon =
            currentSortDir === "asc" ? (
              <SortAmountAscIcon size={size} />
            ) : (
              <SortAmountDescIcon size={size} />
            );
          break;
      }
    }

    return (
      <StyledTh
        isClickable={sortField && true}
        onClick={() =>
          sortField && setSort({ sortField, sortDir: sortDirOnClick })}
      >
        {title} {sortIcon}
      </StyledTh>
    );
  }
}

const StyledTh = styled.th`
  user-select: none;
  ${props => props.isClickable && "cursor: pointer"};
`;

export default TableHeader;



// WEBPACK FOOTER //
// ./src/components/Table/TableHeader.js